export class CreateCredentialsProfileInputAwsCredentialProfile {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "roleArn",
            "baseName": "roleArn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateCredentialsProfileInputAwsCredentialProfile.attributeTypeMap;
    }
    constructor() {
    }
}
